import React, {
  useCallback,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react"
import { UserContext } from "../../../context/userContext"
import trcss from "../../../styles/Telerecovery.module.css"
// Comps
import ChatComponent from "./ChatComponent"
import { trApiGetChatConversationSid } from "../telerecoveryApi"
import { LoaderMedium } from "../../../components/Loaders"

const TRChatMessagesIndex = ({ selectedConv, onNewMessage }) => {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [chatConvSid, setChatConvSid] = useState(selectedConv?.sid)
  const [participant, setParticipant] = useState(selectedConv?.participant)
  const [loading, setLoading] = useState(false)

  const getConversationSid = useCallback(() => {
    setLoading(true)
    trApiGetChatConversationSid(
      userCtx.tokens.getTelerecoveryToken(),
      user.staff_id,
      userCtx.participant_id,
      user.organization_id,
    )
      .then(
        (response) => {
          setChatConvSid(response)
        },
        (err) => console.log(err),
      )
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }, [user.staff_id, userCtx.participant_id])

  useEffect(() => {
    setChatConvSid(selectedConv?.sid)
    setParticipant(selectedConv?.participant)
  }, [selectedConv])

  const participantName = useMemo(() => {
    if (!userCtx.participant_name_first || !userCtx.participant_name_last)
      return ""
    return `${userCtx.participant_name_first} ${userCtx.participant_name_last}`
  }, [userCtx.participant_name_first, userCtx.participant_name_last])

  const participantInitials = useMemo(() => {
    if (!userCtx.participant_name_first || !userCtx.participant_name_last)
      return ""
    return (
      userCtx.participant_name_first.charAt(0).toUpperCase() +
      userCtx.participant_name_last.charAt(0).toUpperCase()
    )
  }, [userCtx.participant_name_first, userCtx.participant_name_last])

  useEffect(() => {
    if (!selectedConv) {
      getConversationSid()
      setParticipant({ name: participantName, initials: participantInitials })
    }
  }, [getConversationSid])

  if (loading) {
    return LoaderMedium()
  }

  return (
    <div className={trcss.chatWrapper}>
      {chatConvSid && (
        <ChatComponent
          chatConvSid={chatConvSid}
          participant={participant}
          onNewMessage={onNewMessage}
        ></ChatComponent>
      )}
    </div>
  )
}
export default TRChatMessagesIndex
